import { useTranslation } from 'react-i18next';
import { Alert, Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { styled } from '@mui/material';

export type DeleteCompletedEvaluatorsDialogProps = {
  open: boolean;
  onClose: () => void;
  handleConfirmDelete: () => void;
};

const ImportantText = styled(TextV2)({ fontSize: '18px !important' });
const Subheader = styled(TextV2)({ margin: `0.25rem 0 0 !important` });
const Content = styled('div')({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

const DeleteCompletedEvaluatorsDialog = ({
  open,
  onClose,
  handleConfirmDelete,
}: DeleteCompletedEvaluatorsDialogProps) => {
  const { t } = useTranslation();

  const content = (
    <Content>
      <ImportantText component="span">
        {t(
          'ui.event-management.evaluator-links.completed-evaluators.confirm-delete.body-text',
        )}
      </ImportantText>
      <br />
      <Subheader component="span">
        {t(
          'ui.event-management.evaluator-links.completed-evaluators.confirm-delete.description',
        )}
      </Subheader>
      <br />
      <Alert severity="error">
        {t(
          'ui.event-management.evaluator-links.completed-evaluators.confirm-delete.warning',
        )}
      </Alert>
    </Content>
  );
  const title = t(
    'ui.event-management.evaluator-links.completed-evaluators.confirm-delete.title',
  );
  const confirmText = t(
    'ui.event-management.evaluator-links.completed-evaluators.confirm-delete.confirm-button',
  );
  const cancelText = t(
    'ui.event-management.evaluator-links.completed-evaluators.confirm-delete.cancel-button',
  );
  return (
    <Dialog
      dialogProps={{
        title,
        maxWidth: 'md',
      }}
      title={title}
      content={content}
      open={open}
      primaryButtonText={confirmText}
      secondaryButtonText={cancelText}
      onSubmit={handleConfirmDelete}
      onClose={onClose}
      primaryButtonColour="error"
    />
  );
};

export default DeleteCompletedEvaluatorsDialog;
